import { type FC } from 'react'

export const ErrorTemplate: FC<{ title: string; onClick: () => void }> = ({ title, onClick }) => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="text-center">
      <h1 className="text-2xl font-bold text-red-600">Oups!</h1>
      <p className="mt-2 text-gray-600">{title}</p>
      <button onClick={onClick} className="mt-4 rounded-sm bg-blue-500 px-4 py-2 text-white hover:bg-blue-600">
        Try again
      </button>
    </div>
  </div>
)
